<!-- basic template for most components -->
<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand :to="{ path: '/' }">
      <img src="/static/images/general/Jeffco_Logo_02.svg" alt="Outline of Jefferson County's geographical area." class="image-flex mr-3" style="width: 40px;" />
      Jefferson County<span class="d-none d-sm-none d-md-inline">, Ohio</span>
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">

      <!-- links start here -->
      <b-navbar-nav>
      
        <!-- online services ======================================= -->
        <b-nav-item-dropdown text="Online Services" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons text-jeff-yellow" style="padding-right: 4px;">apps</i>
            <span class="align-top">Online Services</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/coronavirus' }">Coronavirus Updates</b-dropdown-item>
          <b-dropdown-item href="https://www.doglicenses.us/OH/Jefferson/">Dog License Purchasing</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/downloadable-forms' }">Downloadable Forms</b-dropdown-item>
          <b-dropdown-item href="https://gis.jeffersoncountyoh.com">Online GIS and County Maps</b-dropdown-item>
          <b-dropdown-item href="http://www1.jeffersoncountyoh.com/tax/realdown.htm" target="blank">Real Estate Downloads</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/auditor/real-estate' }">Real Estate Search</b-dropdown-item>
          <b-dropdown-item href="http://probate.jeffersoncountyoh.com" target="blank">Probate Records Search</b-dropdown-item>
          <b-dropdown-item href="http://public.jeffersoncountyoh.com/tax/Range.htm" target="blank">Land Sales Analysis</b-dropdown-item>
          <b-dropdown-item href="http://www1.jeffersoncountyoh.com/gis/GisTaxMaps.htm" target="blank">Scanned County Maps</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/tax-sales' }">Tax Sales</b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- county offices ======================================= -->
        <b-nav-item-dropdown text="County Offices" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons text-jeff-yellow" style="padding-right: 4px;">place</i>
            <span class="align-top">County Offices</span>
          </template>
          
          <b-dropdown-item href="https://www.jeffersoncountyairpark.net">Air Park</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/auditor' }">Auditor's Office</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/auto-dept' }">Auto Title Department</b-dropdown-item>
          <b-dropdown-item href="http://www.jcbdd.com/">Board of Developmental Disabilities</b-dropdown-item>
          <b-dropdown-item href="https://www.boe.ohio.gov/jefferson/">Board of Elections</b-dropdown-item>
          <b-dropdown-item href="http://www.jchealth.com/">Board of Health</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/commissioners' }">County Commissioners</b-dropdown-item>
          <b-dropdown-item href="https://www.jeffersoncountyengineer.com/">County Engineer's Office</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/ema' }">Emergency Management Agency</b-dropdown-item>

          <div class="dropdown-divider"></div>

          <b-dropdown-item href="http://www.jcdjfs.com/">Job &amp; Family Services</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/recorder' }">Recorder's Office</b-dropdown-item>
          <!-- <b-dropdown-item href="http://rpc.jeffersoncountyoh.com/">Regional Planning Commission</b-dropdown-item> -->
          <b-dropdown-item :to="{ path: '/regional-planning' }">Regional Planning Commission</b-dropdown-item>
          <b-dropdown-item href="http://www.jeffersoncountysheriff.com/">Sheriff's Office</b-dropdown-item>
          <b-dropdown-item href="http://www.jeffersonswcd.org/">Soil &amp; Water Conservation</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/treasurer' }">Treasurer's Office</b-dropdown-item>
          <b-dropdown-item href="http://jvets.net/">Veteran's Service Commission</b-dropdown-item>
          <b-dropdown-item href="http://www.jcwatersewer.com/">Water &amp; Sewer</b-dropdown-item>
          <b-dropdown-item href="https://friendship.jeffersoncountyoh.com/">Friendship Park</b-dropdown-item>

        </b-nav-item-dropdown>

        <!-- county courts ======================================= -->
        <b-nav-item-dropdown text="Courts" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons text-jeff-yellow" style="padding-right: 4px;">gavel</i>
            <span class="align-top">Courts</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/court/common-pleas' }">Common Pleas</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/court/appeals' }">Court Of Appeals</b-dropdown-item>
          <b-dropdown-item href="https:\\www.jeffersoncountyprobatejuvenile.com">Probate Court</b-dropdown-item>
          <b-dropdown-item href="https:\\www.jeffersoncountyprobatejuvenile.com">Juvenile Court</b-dropdown-item>
          <b-dropdown-item href="https://www.jeffersoncountyohcoc.com/">Clerk Of Courts</b-dropdown-item>
          <b-dropdown-item href="https:\\www.jeffersoncountyprobatejuvenile.com">Detention Center</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/court/dillonvale' }">County Court - Dillonvale</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/court/toronto' }">County Court - Toronto</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/court/wintersville' }">County Court - Wintersville</b-dropdown-item>
          <b-dropdown-item :to="{ path: '/law-library' }">Law Library</b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- county info ======================================= -->
        <b-nav-item-dropdown text="County Info" class="mr-2">
          
          <template slot="button-content">
            <i class="material-icons text-jeff-yellow" style="padding-right: 4px;">label</i>
            <span class="align-top">County Info</span>
          </template>
          
          <b-dropdown-item :to="{ path: '/county-directory' }">County Directory</b-dropdown-item>
        </b-nav-item-dropdown>

        <!-- <b-nav-item class="text-danger" href="#">Plain link</b-nav-item> -->

      </b-navbar-nav>
      <!-- links end -->

    </b-collapse>
  </b-navbar>
</template>

<script>

import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar'
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav'
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand'
import bNavbarToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle'
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item'  
import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown'

export default {
    components: {
    bCollapse,
    bDropdownItem,
    bNavbar,
    bNavbarNav,
    bNavbarBrand,
    bNavbarToggle,
    bNavItem,
    bNavItemDropdown
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style>
</style>
